import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtAddonZoomDrawerCtrl($scope, $timeout, ItemService, RouterService, AddOnService, $rootScope) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);
  this.selectItem = function () {
    this.close();
    RouterService.goToAddOnDetail($scope.zoomAddOn.item.skuCode);
  };
  this.addToCart = function () {
    const item = $scope.zoomAddOn;
    $rootScope.$broadcast('lt-addon-added-to-cart', { item: item });
    this.popUpAction();
  };
  this.popUpAction = function () {
    ItemService.popUpAction = true;
    this.close();
  };
  this.customizeItem = function () {
    this.close();
    RouterService.goToTextPersonalizer('addon', $scope.zoomAddOn.item.skuCode);
  };
  this.getButtonType = function () {
    const item = this.item || $scope.zoomAddOn;
    const itemData = item?.item;
    if (!itemData) {
      return null;
    }
    const isPersonalizerEnabled = ItemService.isPersonalizerEnabled(itemData);
    const lookSelectionAllowed = itemData.lookSelectionAllowed;

    if (isPersonalizerEnabled) {
      return 'PERSONALIZE_BUTTON';
    }
    return lookSelectionAllowed ? 'CUSTOMIZE_BUTTON' : 'ADD_TO_CART';
  };

  this.hasDiscount = () => {
    return AddOnService.hasDiscount($scope?.zoomAddOn?.item);
  };
}

App.controller('LtAddonZoomDrawerCtrl', [
  '$scope',
  '$timeout',
  'ItemService',
  'RouterService',
  'AddOnService',
  '$rootScope',
  LtAddonZoomDrawerCtrl
]);
